import { render, staticRenderFns } from "./BaseDrawerSCSS.vue?vue&type=template&id=66d26f08"
import script from "./BaseDrawerSCSS.vue?vue&type=script&lang=js"
export * from "./BaseDrawerSCSS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports